"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateStylableBreakpoints = exports.generateStylableTheme = exports.generateStylableThemeVars = exports.generateGlobalProperties = void 0;
var tslib_1 = require("tslib");
var consts_1 = require("../consts");
var font_utils_1 = require("../fonts/font-utils");
var generateSiteColorVarKey = function (x, y) { return "site_".concat(x, "_").concat(y); };
var varsBlock = function (declarations) {
    return ":vars {\n".concat(Object.keys(declarations)
        .map(function (name) { return "    ".concat(name, ": ").concat(declarations[name], ";"); })
        .join('\n'), "\n}");
};
function generateGlobalProperties(globalProperties) {
    var globalPropertyDefinitions = globalProperties.map(function (property) { return "@property st-global(--".concat(property, ") {}"); });
    return globalPropertyDefinitions.join('\n');
}
exports.generateGlobalProperties = generateGlobalProperties;
var classRule = function (className, declarations) {
    return ".".concat(className, " { ").concat(Object.keys(declarations)
        .map(function (name) { return "".concat(name, ": ").concat(declarations[name], ";"); })
        .join(' '), " }");
};
var OLD_PALETTE_FIRST = 11;
var OLD_PALETTE_LAST = 35;
var MATRIX_DIMENSION = 5;
// 11-15, 18, 45-65 are the colors from new palette
var NEW_PALETTE_INDICES = new Set(tslib_1.__spreadArray([
    11,
    12,
    13,
    14,
    15,
    18
], tslib_1.__read(Array(30)
    .fill(null)
    .map(function (_, i) { return i + 36; })), false));
// set null to colors that are not in the palette
function getOnlyNewPaletteColors(colors) {
    return colors === null || colors === void 0 ? void 0 : colors.map(function (color, idx) { return (NEW_PALETTE_INDICES.has(idx) ? color : null); });
}
function generateStylableThemeVars(themeData, shouldGenerateNewPalette) {
    var _a, _b, _c;
    var xFromIndex = function (index) { return Math.floor(index / MATRIX_DIMENSION) + 1; };
    var yFromIndex = function (index) { return Math.floor(index % MATRIX_DIMENSION) + 1; };
    var stylableThemeObj = (_b = (_a = themeData[consts_1.THEME_COLOR_KEY]) === null || _a === void 0 ? void 0 : _a.slice(OLD_PALETTE_FIRST, OLD_PALETTE_LAST + 1)) === null || _b === void 0 ? void 0 : _b.reduce(function (siteColorVars, color, index) {
        siteColorVars[generateSiteColorVarKey(xFromIndex(index), yFromIndex(index))] = color;
        return siteColorVars;
    }, {});
    var newPaletteObj = shouldGenerateNewPalette
        ? (_c = getOnlyNewPaletteColors(themeData[consts_1.THEME_COLOR_KEY])) === null || _c === void 0 ? void 0 : _c.reduce(function (acc, color, index) {
            // don't include colors with null
            if (color) {
                acc["color_".concat(index)] = color;
            }
            return acc;
        }, {})
        : {};
    // Return both objects for compatibility
    return varsBlock(tslib_1.__assign(tslib_1.__assign({}, stylableThemeObj), newPaletteObj));
}
exports.generateStylableThemeVars = generateStylableThemeVars;
function generateStylableTheme(_a) {
    var themeData = _a.themeData, fontThemes = _a.fontThemes, shouldGenerateNewPalette = _a.shouldGenerateNewPalette, globalCssVariables = _a.globalCssVariables, usePanelThemeFonts = _a.usePanelThemeFonts;
    var siteColorsVarsString = generateStylableThemeVars(themeData, shouldGenerateNewPalette);
    var fontThemeClasses = fontThemes || (0, font_utils_1.getFontThemeClasses)(themeData);
    var fontThemeClassesString = Object.keys(fontThemeClasses)
        .map(function (fontStyleName) { return classRule(fontStyleName, fontThemeClasses[fontStyleName]); })
        .join('\n');
    var globalCssVariablesString = globalCssVariables ? generateGlobalProperties(globalCssVariables) : null;
    var themeSpxString = usePanelThemeFonts ? consts_1.themeSpxImport : null;
    return [themeSpxString, siteColorsVarsString, fontThemeClassesString, globalCssVariablesString].filter(Boolean).join('\n');
}
exports.generateStylableTheme = generateStylableTheme;
function generateStylableBreakpoints(isMobile) {
    var _a;
    return varsBlock((_a = {},
        _a[consts_1.mobileMediaQueryVarName] = isMobile ? consts_1.mobileMediaQueryOn : consts_1.mobileMediaQueryOff,
        _a));
}
exports.generateStylableBreakpoints = generateStylableBreakpoints;
//# sourceMappingURL=injections.js.map